module.exports = __webpack_public_path__ + "imgs/linkedin-white.c76701de3f73075e0c2e624184f04b67.svg";